import { useSelector } from "react-redux";
import styles from "./index.module.less";
function ImageryLegend() {
  const detection = useSelector((state) => state.panel.detection);
  if (!detection) {
    return null;
  }
  return (
    <div className={`${styles.imageryLegendPanel}  panel-container`}>
      <div className="item">
        <div className="color water"></div>
        <div className="label">Water</div>
      </div>
      <div className="item">
        <div className="color ice"></div>
        <div className="label">Sea ice</div>
      </div>
    </div>
  );
}

export default ImageryLegend;
